import autoformPlaceholder from '../images/autoform-unselected.png';
import { Navigate } from 'react-router-dom';
import AutoformPage from 'pages/AutoformPage';
import WrapperEmptyState from 'components/layout/WrapperEmptyState';
import AutoformContainer from 'components/autoform/AutoformContainer';
import FuelsAndEmissionsPage from 'pages/FuelsAndEmissions';
import { FUEL_EMISSIONS_ROUTES } from 'constants/routes';

export const fuelAndEmissionsRoutes = {
    path: '/fuels-and-emissions',
    element: <FuelsAndEmissionsPage />,
    children: [
        {
            index: true,
            element: <Navigate to={`${FUEL_EMISSIONS_ROUTES.PSBLENDS}/${window.location.search}`} />,
        },
        {
            path: FUEL_EMISSIONS_ROUTES.PSBLENDS,
            element: <AutoformPage config={{ autoformId: FUEL_EMISSIONS_ROUTES.PSBLENDS }} hasSecondaryMenu={true} />,
            children: [
                {
                    index: true,
                    element: (
                        <WrapperEmptyState imgSrc={autoformPlaceholder} item="record" page="left" noun="properties" />
                    ),
                },
                {
                    path: ':itemId',
                    element: <AutoformContainer />,
                },
            ],
        },
        {
            path: FUEL_EMISSIONS_ROUTES.PSFUELEMISSIONRATES,
            element: (
                <AutoformPage
                    config={{ autoformId: FUEL_EMISSIONS_ROUTES.PSFUELEMISSIONRATES }}
                    hasSecondaryMenu={true}
                />
            ),
            children: [
                {
                    index: true,
                    element: (
                        <WrapperEmptyState imgSrc={autoformPlaceholder} item="record" page="left" noun="properties" />
                    ),
                },
                {
                    path: ':itemId',
                    element: <AutoformContainer />,
                },
            ],
        },
    ],
};
